module.exports = __webpack_public_path__ + "img/bgindex_01.bebb3db0.png";